import { FeedbackIssueBadge } from '@/components/feedbacks/feedback-issue-badge';
import { SessionFeedbackIssue } from '@airreading/common/data';

export const ReadonlyIssuesList = ({ issues }: { issues: SessionFeedbackIssue[] }) => {
  return (
    <div className="flex flex-wrap items-start gap-1">
      {issues.map((item) => (
        <FeedbackIssueBadge feedbackIssue={item} key={item} />
      ))}
    </div>
  );
};
